import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grow, IconButton, List, ListItem, TextField, Typography } from '@material-ui/core';
import { createStyles, StyledComponentProps, Theme, withStyles } from '@material-ui/core/styles';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import { AddShoppingCart } from '@material-ui/icons';
import CancelIcon from '@material-ui/icons/Cancel';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IEntity, IEntityStore, INamedEntity } from '../main/entities';
import { transl } from '../main/transl';
import { getOmnistore } from '../stores/Omnistore';
import { AmountToOrderDialog } from './AmountToOrderDialog';
import { EntityImage } from './EntityImage';

// eslint-disable-next-line react/display-name
const Transition = React.forwardRef((props: TransitionProps, ref) => <Grow {...props} ref={ref}/>);

const styles = (theme: Theme) => createStyles({
	dialog: {
	},
	dialogContent: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	paper: {
		width: '100%',
		flex: 1,
		display: 'flex',
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
	itemImage: {
		display: 'block',
		maxWidth: '80%',
		width: 'auto',
		height: 'auto',
		margin: '10px auto',
		maxHeight: '200px',
	},
	disabled: {
		color: '#EE0000',
	},
});

interface IChanges {
	amountToOrder?: number
	isDeleted?: boolean
	category?: string
}

export interface ICombiItem extends INamedEntity {
	advertisementId?: number,
	amountStep: number
	isInvalid: boolean
	availability?: string
	templateItemId?: number
	imageLink: string
	templateId: number
	supplierId: number
	supplierName: string
	category?: string
	packaging: string
	itemNo: string
	eancode: string
}

interface IItemDetailProps {
	entity: ICombiItem | undefined
	state: {
		rowClick(n: number) : void
	}
	repo: IEntityStore
	onDelete?(): void
	categories: Array<string>
	fetchCurrentCategories?: () => void
}

@observer export class _ItemDetail extends React.Component<IItemDetailProps & StyledComponentProps> {
	@observable _changes: IChanges = {}

	@observable _hasError = false

	@computed get _isPristine() {
		return !Object.keys(this._changes).length;
	}

	@action _onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const target = event.target;
		let v: string | number = target.value;
		if (target.type==='number') v = +v>0 ? +v : 0;
		(this._changes as any)[target.name] = v;
	}

	@action _onCategoryChange = (event: React.ChangeEvent<{}>, value: string | null) => {
		this._changes['category'] = value ?? '';
	}

	@action _onClose = () => {
		this.props.state.rowClick(0);
		this._changes = {};
	}

	@action _onAccept = () => {
		const {entity, repo, fetchCurrentCategories} = this.props;
		if (!entity) throw new Error('no entity');
		const amountToOrder = this._changes.amountToOrder;
		this._hasError = !!(amountToOrder && amountToOrder % entity!.amountStep !== 0);
		if (this._hasError) return;
		console.log('_onAccept', entity, this._changes);
		if (entity.id > 0) {
			const e: IEntity = {...entity, ...this._changes};
			repo.upserter.update(e)
				.then(() => this._changes.category!==undefined && fetchCurrentCategories?.())
				.then(this._onClose);
		} else {
			const multirepo = getOmnistore().multirepo;
			const templateId = multirepo.templateRepo.allAsList.filter(t => t.supplierId==entity.supplierId).map(t => t.id)[0];
			const e: any = {...entity, ...this._changes, templateId}; //TODO
			repo.upserter.create(e)
				.then(this._onClose);
		}
	}

	@action _onAdd = () => {
		const {entity, repo} = this.props;
		repo.upserter.create(entity as any) //TODO
			.then(this._onClose);
	}

	@action _onDelete = () => {
		const {entity, repo, onDelete} = this.props;
		if (onDelete) {
			onDelete();
		} else {
			repo.upserter.delete(entity as any) //TODO
				.then(this._onClose);
		}
	}

	@action _onCloseIfPristine = () => {
		if (this._isPristine) this._onClose();
	}

	@action _onDialogClose = (event: React.MouseEvent) => {
		event.preventDefault();
		event.stopPropagation();
		// this._changes.amountToOrder = +event.currentTarget.name; //TODO this makes no sense
		this._onAccept();
	}

	_readonlyFields: Array<keyof ICombiItem> = [
		'supplierName',
		'packaging',
		'itemNo',
		'eancode',
		'availability',
	]

	@computed get _isCatalog() {
		return getOmnistore().locationStore.page==='LCatalog';
	}

	@computed get _editableFields() {
		const e = this.props.entity;
		return this._isCatalog || !e || e.advertisementId ? [] : [
			{
				name: 'amountToKeep',
				type: 'number',
				min: 0,
			},
			{
				name: 'amountToOrder',
				type: 'number',
				min: 0,
				step: this.props.entity!.amountStep,
			},
		];
	}

	_renderDialogContent() {
		const classes = this.props.classes || {};
		const {entity, categories} = this.props;
		if (!entity) return null;
		const e = {...entity, ...this._changes};

		console.log('categories.length', categories.length);

		if (e.isInvalid) e.availability = transl('discontinued');
		if (!e.amountStep) e.amountStep = 1;

		const classesDisabled = entity.isInvalid ? classes.disabled : undefined;

		return <>
			<EntityImage className={classes.itemImage} entity={e} tooltip=""/>
			<List dense>{
				this._readonlyFields.map(f =>
					<ListItem key={f} style={{display: 'flex', flexDirection: 'row'}}>
						<Typography style={{display: 'flex', flex: 40}} className={classesDisabled}>
							{transl(f)}
						</Typography>
						<Typography style={{display: 'flex', flex: 60}} className={classesDisabled}>
							{e[f]}
						</Typography>
					</ListItem>)
			}</List>
			<List dense>
				<ListItem key="category" style={{display: 'flex', flexDirection: 'row'}}>
					<Typography style={{display: 'flex', flex: 40}} className={classesDisabled}>
						{transl('category')}
					</Typography>
					<Autocomplete
						freeSolo
						options={categories}
						multiple={false}
						value={e.category}
						onChange={this._onCategoryChange}
						style={{display: 'flex', flex: 60}}
						renderInput={params =>
							<TextField {...params} name="category" onChange={this._onChange} disabled={e.isInvalid}/>}/>
				</ListItem>
				{
					this._editableFields.map(f =>
						<ListItem key={f.name} style={{display: 'flex', flexDirection: 'row'}}>
							<Typography style={{display: 'flex', flex: 40}} className={classesDisabled}>
								{transl(f.name)}
							</Typography>
							<TextField style={{display: 'flex', flex: 60}} inputProps={f} value={(e as any)[f.name]} onChange={this._onChange} disabled={e.isInvalid}/>
						</ListItem>)
				}
			</List>
		</>;
	}

	render() {
		const classes = this.props.classes || {};
		const {entity} = this.props;
		if (!entity) return null;

		const classesDisabled = entity.isInvalid ? classes.disabled : undefined;
		return <Dialog
			open={true}
			onClose={this._onCloseIfPristine}
			TransitionComponent={Transition}
			className={classes.dialogContent}
			classes={{paper: classes.paper}}
		>
			<DialogTitle className={classesDisabled} classes={{root: classesDisabled}}>
				<span className={classesDisabled}>{entity.name}</span>
				{
					this._isPristine
						?
						<IconButton aria-label="Close" className={classes.closeButton} onClick={this._onClose}>
							<CloseIcon/>
						</IconButton>
						:
						null
				}
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				{this._renderDialogContent()}
			</DialogContent>
			<DialogActions>
				{
					getOmnistore().locationStore.page!=='LTemplates' && !entity.isInvalid && !entity.advertisementId ? null :
						<Button onClick={this._onDelete} style={{color: '#FF0000'}} startIcon={<DeleteIcon />}>{transl('delete')}</Button>
				}
				{
					entity.isInvalid || entity.advertisementId ? null :
						this._isCatalog
							?
							entity.templateItemId ? null :
								<Button onClick={this._onAdd} color="primary" startIcon={<AddShoppingCart />}>{transl('addToTemplate')}</Button>
							:
							<Button onClick={this._onAccept} color="primary" startIcon={<SaveIcon/>}>{transl('save')}</Button>
				}
				<Button onClick={this._onClose} style={{color: '#666666'}} startIcon={<CancelIcon/>}>{transl('cancel')}</Button>
			</DialogActions>
			{
				!this._hasError || !this._changes.amountToOrder ? null :
					<AmountToOrderDialog
						value={this._changes.amountToOrder}
						step={entity.amountStep}
						onClose={this._onDialogClose}
					/>
			}
		</Dialog>;
	}
}

export const ItemDetail = withStyles(styles)(_ItemDetail);
